import { render, staticRenderFns } from "./orderOverview.vue?vue&type=template&id=bec28f4e&scoped=true"
import script from "./orderOverview.vue?vue&type=script&lang=js"
export * from "./orderOverview.vue?vue&type=script&lang=js"
import style0 from "./orderOverview.vue?vue&type=style&index=0&id=bec28f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec28f4e",
  null
  
)

export default component.exports